/* tslint:disable */
/* eslint-disable */
/**
 * Gallaudet
 * A set of APIs to allow seamless integration of the NUSA Roblox game
with Google Classrooms.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated.
 * Do not edit the class manually.
 */
import { exists, mapValues } from './model-utils';

/**
 * 
 * @export
 * @interface GetRobloxSecretStoreAccessStatusResponseContent
 */
export interface GetRobloxSecretStoreAccessStatusResponseContent {
    /**
     * 
     * @type {boolean}
     * @memberof GetRobloxSecretStoreAccessStatusResponseContent
     */
    delegated: boolean;
}


/**
 * Check if a given object implements the GetRobloxSecretStoreAccessStatusResponseContent interface.
 */
export function instanceOfGetRobloxSecretStoreAccessStatusResponseContent(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "delegated" in value;
    return isInstance;
}

export function GetRobloxSecretStoreAccessStatusResponseContentFromJSON(json: any): GetRobloxSecretStoreAccessStatusResponseContent {
    return GetRobloxSecretStoreAccessStatusResponseContentFromJSONTyped(json, false);
}

export function GetRobloxSecretStoreAccessStatusResponseContentFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetRobloxSecretStoreAccessStatusResponseContent {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'delegated': json['delegated'],
    };
}

export function GetRobloxSecretStoreAccessStatusResponseContentToJSON(value?: GetRobloxSecretStoreAccessStatusResponseContent | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'delegated': value.delegated,
    };
}

